// extracted by mini-css-extract-plugin
module.exports = {"button":"preview_cover_button__xA0F2","text":"preview_cover_text__cHY0i"};